import type { IPlace } from "@bbj-types/address";
import { Autocomplete, type AutocompleteProps } from "@mui/material";
import type React from "react";
import { getOptionLabel, isOptionEqualToValue } from "./utils";

type TAutoCompletePlacesUniqBaseProps<
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  ChipComponent extends React.ElementType = "div",
> = Omit<
  AutocompleteProps<IPlace, Multiple, DisableClearable, false, ChipComponent>,
  "isOptionEqualToValue" | "getOptionLabel"
>;
export const AutocompletePlacesUniqBase = <
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
>({
  ...props
}: TAutoCompletePlacesUniqBaseProps<Multiple, DisableClearable>) => {
  return (
    <Autocomplete
      getOptionLabel={getOptionLabel}
      filterOptions={(x) => x}
      isOptionEqualToValue={isOptionEqualToValue}
      {...props}
    />
  );
};
